
























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class MultiSelect extends Vue {
  @Prop({ type: Array, required: true }) options!: { value: string; label: string }[];
  @Prop({ type: Array, default: () => [] }) value!: string[];
  @Prop({ type: String, default: 'Chọn một hoặc nhiều mục' }) placeholder!: string;
  @Prop({ type: Boolean, default: false }) disable!: boolean;

  isOpen = false;
  selectedValues: string[] = [];

  @Watch('value', { immediate: true })
  onValueChange(newValue: string[]) {
    this.selectedValues = newValue;
  }

  @Watch('selectedValues')
  onSelectedValuesChange(newValues: string[]) {
    this.$emit('input', newValues);
  }

  get selectedLabels() {
    return this.options.filter(option => this.selectedValues.includes(option.value)).map(option => option.label);
  }

  arrowColor() {
    return localStorage.getItem('theme') !== 'light' ? 'white' : 'black';
  }

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  mounted() {
    document.addEventListener('click', this.closeDropdown);
  }

  beforeDestroy() {
    document.removeEventListener('click', this.closeDropdown);
  }

  closeDropdown(event: Event) {
    if (!this.$el.contains(event.target as Node)) {
      this.isOpen = false;
    }
  }
}
